import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title: "TMS for Police Officers | Neuro Wellness TMS",
  description:
    "Police officers: learn about TMS therapy, SAINT TMS, and mental health treatment options for depression, anxiety, and PTSD in Coral Springs, FL.",
  canonical: "/tms-for-police-officers",
  keywords:
    "TMS for police officers, police officer depression treatment, law enforcement TMS therapy, police PTSD treatment Florida",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  { title: "TMS for Sheriff's Deputies", href: "/tms-for-sheriffs-deputies" },
  {
    title: "Depression Treatment for First Responders",
    href: "/depression-treatment-for-first-responders",
  },
  {
    title: "First Responder Insurance Verification",
    href: "/first-responder-insurance-verification",
  },
  { title: "PTSD and TMS", href: "/services/ptsd" },
];

export default function TmsForPoliceOfficers() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="Police Officers"
      title="TMS for Police Officers"
      subtitle="Law enforcement officers face high rates of depression, anxiety, and PTSD. If medication hasn't worked, there are other options."
    >
      <DecisionSection heading="What police officers experience">
        <p>
          Police work exposes you to trauma that most people never see. Over
          years of shifts, calls, and critical incidents, that exposure adds up.
          Depression, anxiety, hypervigilance, and PTSD are common in law
          enforcement — and they're not signs that you can't handle the job.
          They're responses to what the job asks of you.
        </p>
        <p>
          If you've tried antidepressants and they haven't given you the relief
          you need, there are other approaches that work differently.
        </p>
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "TMS — FDA-cleared, non-invasive magnetic stimulation for depression",
            "SAINT accelerated TMS — five-day protocol, FDA-cleared, with fMRI targeting",
            "SPRAVATO (esketamine) — FDA-approved for treatment-resistant depression and MDD with suicidal thoughts",
            "Prism for PTSD — EEG neurofeedback specifically for PTSD symptoms",
            "IV ketamine and KAP — for depression, anxiety, and PTSD",
            "Trauma-informed psychotherapy — CBT, EMDR, and other approaches",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Confidentiality and your career">
        <p>
          Your treatment at Neuro Wellness TMS Centers of America is completely
          confidential. We do not contact your department, your employer, or
          anyone else without your written consent. Seeking treatment does not
          affect your career, and your records are protected by HIPAA.
        </p>
      </DecisionSection>

      <DecisionSection heading="Insurance">
        <p>
          Many police officers have insurance through their municipal or
          departmental plan. Coverage for TMS, SAINT, and other treatments
          varies by individual plan. Our team verifies your benefits and handles
          authorization on your behalf.
        </p>
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/first-responder-insurance-verification"
            className="text-accent hover:underline"
          >
            verify your insurance
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
